import AttendanceIconActive from "assets/img/Sidebar/Repositioning/Attendance_Filled_Active.svg";
import AttendanceIconFilled from "assets/img/Sidebar/Repositioning/Attendance_filled.svg";
import AttendanceIconLine from "assets/img/Sidebar/Repositioning/Attendance_line.svg";
import ClientsIconActive from "assets/img/Sidebar/Repositioning/Customer_Filled_Active.svg";
import ClientsIconFilled from "assets/img/Sidebar/Repositioning/Customer_filled.svg";
import ClientsIconLine from "assets/img/Sidebar/Repositioning/Customer_line.svg";
import DashboardIconFilled from "assets/img/Sidebar/Repositioning/Dashboard_Filled.svg";
import DashboardIconActive from "assets/img/Sidebar/Repositioning/Dashboard_Filled_Active.svg";
import DashboardIconLine from "assets/img/Sidebar/Repositioning/Dashboard_Line.svg";
import GPSTrackIconActive from "assets/img/Sidebar/Repositioning/GPS_tracking_Filled_Active.svg";
import GPSTrackIconFilled from "assets/img/Sidebar/Repositioning/GPS_tracking_filled.svg";
import GPSTrackIconLine from "assets/img/Sidebar/Repositioning/GPS_tracking_line.svg";
import IntegrationsIconFilled from "assets/img/Sidebar/Repositioning/Integration_Filled.svg";
import IntegrationsIconActive from "assets/img/Sidebar/Repositioning/Integration_Filled_Active.svg";
import IntegrationsIconLine from "assets/img/Sidebar/Repositioning/Integration_Line.svg";
import InvoiceIconFilled from "assets/img/Sidebar/Repositioning/Invoice_Filled.svg";
import InvoiceIconActive from "assets/img/Sidebar/Repositioning/Invoice_Filled_Active.svg";
import InvoiceIconLine from "assets/img/Sidebar/Repositioning/Invoice_Line.svg";
import MembersIconFilled from "assets/img/Sidebar/Repositioning/Member_Filled.svg";
import MembersIconActive from "assets/img/Sidebar/Repositioning/Member_Filled_Active.svg";
import MembersIconLine from "assets/img/Sidebar/Repositioning/Member_Line.svg";
import OfficesIconActive from "assets/img/Sidebar/Repositioning/Office_Filled_Active.svg";
import OfficesIconFilled from "assets/img/Sidebar/Repositioning/Office_filled.svg";
import OfficesIconLine from "assets/img/Sidebar/Repositioning/Office_line.svg";
import OrganizationsIconFilled from "assets/img/Sidebar/Repositioning/Organization_Filled.svg";
import OrganizationsIconActive from "assets/img/Sidebar/Repositioning/Organization_Filled_Active.svg";
import OrganizationsIconLine from "assets/img/Sidebar/Repositioning/Organization_Line.svg";
import PayrollIconActive from "assets/img/Sidebar/Repositioning/Payroll_Filled_Active.svg";
import PayrollIconLine from "assets/img/Sidebar/Repositioning/Payroll_Line.svg";
import PayrollIconFilled from "assets/img/Sidebar/Repositioning/Payroll_filled.svg";
import QuickActionsIconFilled from "assets/img/Sidebar/Repositioning/Quick_Actions_Filled.svg";
import QuickActionsIconActive from "assets/img/Sidebar/Repositioning/Quick_Actions_Filled_Active.svg";
import QuickActionsIconLine from "assets/img/Sidebar/Repositioning/Quick_Actions_Line.svg";
import RouteOptimizationIconActive from "assets/img/Sidebar/Repositioning/Route_Filled_Active.svg";
import RouteOptimizationIconFilled from "assets/img/Sidebar/Repositioning/Route_filled.svg";
import RouteOptimizationIconLine from "assets/img/Sidebar/Repositioning/Route_line.svg";
import SchedulesIconFilled from "assets/img/Sidebar/Repositioning/Scheduling_Filled.svg";
import SchedulesIconActive from "assets/img/Sidebar/Repositioning/Scheduling_Filled_Active.svg";
import SchedulesIconLine from "assets/img/Sidebar/Repositioning/Scheduling_Line.svg";
import SettingsIconFilled from "assets/img/Sidebar/Repositioning/Settings_Filled.svg";
import SettingsIconActive from "assets/img/Sidebar/Repositioning/Settings_Filled_Active.svg";
import SettingsIconLine from "assets/img/Sidebar/Repositioning/Settings_Line.svg";
import TasksIconFilled from "assets/img/Sidebar/Repositioning/Task_Filled.svg";
import TasksIconActive from "assets/img/Sidebar/Repositioning/Task_Filled_Active.svg";
import TasksIconLine from "assets/img/Sidebar/Repositioning/Task_Line.svg";
import TimesheetIconActive from "assets/img/Sidebar/Repositioning/Timesheet_Filled_Active.svg";
import TimesheetIconFilled from "assets/img/Sidebar/Repositioning/Timesheet_filled.svg";
import TimesheetIconLine from "assets/img/Sidebar/Repositioning/Timesheet_line.svg";
import WorkOrderIconFilled from "assets/img/Sidebar/Repositioning/Work_order_Filled.svg";
import WorkOrderIconActive from "assets/img/Sidebar/Repositioning/Work_order_Filled_Active.svg";
import WorkOrderIconLine from "assets/img/Sidebar/Repositioning/Work_order_Line.svg";
import arrowDown from "assets/img/Sidebar/sidebar-arrow-down.svg";
import { LinkText } from "custom_modules/Sidebar/sidebarStyles";
import { AnimatePresence, motion } from "framer-motion";
import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { generateGroupedLinks } from "../../custom_modules/Sidebar/sidebarHelpers";
import {
  DrawerBody,
  DrawerChildMiniIcon,
  DrawerCollapseChildLink,
  DrawerCollapseChildren,
  DrawerCollapseGroup,
  DrawerCollapseHeader,
  DrawerFooter,
  DrawerGroup,
  DrawerGroupTitle,
  DrawerLinkIcon,
  DrawerLinkItem,
  DrawerPanel,
  OrgIconBadge,
  OrgName,
  OrgSection,
} from "./mobileMenuDrawerStyles";

const iconMap = {
  quickActionsIcon: {
    filled: QuickActionsIconFilled,
    active: QuickActionsIconActive,
    line: QuickActionsIconLine,
  },
  dashboardIcon: {
    filled: DashboardIconFilled,
    active: DashboardIconActive,
    line: DashboardIconLine,
  },
  gpsTrackIcon: {
    filled: GPSTrackIconFilled,
    active: GPSTrackIconActive,
    line: GPSTrackIconLine,
  },
  timesheetIcon: {
    filled: TimesheetIconFilled,
    active: TimesheetIconActive,
    line: TimesheetIconLine,
  },
  clockInOutIcon: {
    filled: AttendanceIconFilled,
    active: AttendanceIconActive,
    line: AttendanceIconLine,
  },
  officesIcon: {
    filled: OfficesIconFilled,
    active: OfficesIconActive,
    line: OfficesIconLine,
  },
  teamsIcon: {
    filled: OfficesIconFilled,
    active: OfficesIconActive,
    line: OfficesIconLine,
  },
  tasksIcon: {
    filled: TasksIconFilled,
    active: TasksIconActive,
    line: TasksIconLine,
  },
  schedulesIcon: {
    filled: SchedulesIconFilled,
    active: SchedulesIconActive,
    line: SchedulesIconLine,
  },
  projectIcon: {
    filled: WorkOrderIconFilled,
    active: WorkOrderIconActive,
    line: WorkOrderIconLine,
  },
  invoiceIcon: {
    filled: InvoiceIconFilled,
    active: InvoiceIconActive,
    line: InvoiceIconLine,
  },
  WorkOrderIcon: {
    filled: WorkOrderIconFilled,
    active: WorkOrderIconActive,
    line: WorkOrderIconLine,
  },
  clientsIcon: {
    filled: ClientsIconFilled,
    active: ClientsIconActive,
    line: ClientsIconLine,
  },
  membersIcon: {
    filled: MembersIconFilled,
    active: MembersIconActive,
    line: MembersIconLine,
  },
  payrollIcon: {
    filled: PayrollIconFilled,
    active: PayrollIconActive,
    line: PayrollIconLine,
  },
  routeOptimizationIcon: {
    filled: RouteOptimizationIconFilled,
    active: RouteOptimizationIconActive,
    line: RouteOptimizationIconLine,
  },
  integrationsIcon: {
    filled: IntegrationsIconFilled,
    active: IntegrationsIconActive,
    line: IntegrationsIconLine,
  },
  organizationsIcon: {
    filled: OrganizationsIconFilled,
    active: OrganizationsIconActive,
    line: OrganizationsIconLine,
  },
  settingsIcon: {
    filled: SettingsIconFilled,
    active: SettingsIconActive,
    line: SettingsIconLine,
  },
};

const isRouteActive = (routePath, pathname) => {
  if (!routePath) return false;
  return pathname === routePath || pathname.startsWith(routePath + "/");
};

// Animation variants
const drawerPanelVariants = {
  hidden: {
    x: "-100%",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30,
      duration: 0.4,
    },
  },
  exit: {
    x: "-100%",
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
};

const drawerBodyVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1,
    },
  },
};

const groupVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
};

const linkItemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
      ease: "easeOut",
    },
  },
};

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

const CollapseSection = ({ route, location, onClose, history }) => {
  const childActive = route.views
    ? route.views.some(v =>
        v.layout && v.path
          ? isRouteActive(v.layout + v.path, location.pathname)
          : false,
      )
    : false;
  const [open, setOpen] = useState(childActive);
  const icons = route.icon ? iconMap[route.icon] : null;
  const iconSrc = childActive
    ? icons?.active || icons?.filled || icons?.line
    : icons?.line || icons?.filled;

  return (
    <DrawerCollapseGroup>
      <DrawerCollapseHeader onClick={() => setOpen(o => !o)}>
        {iconSrc && <DrawerLinkIcon src={iconSrc} alt="" />}
        <LinkText>{route.name}</LinkText>
        <img
          src={arrowDown}
          alt=""
          style={{
            width: 14,
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      </DrawerCollapseHeader>
      {open && (
        <DrawerCollapseChildren>
          {route.views.map((view, idx) => {
            if (!view.layout || !view.path) return null;
            const fullPath = view.layout + view.path;
            const active = isRouteActive(fullPath, location.pathname);
            return (
              <DrawerCollapseChildLink
                key={idx}
                href={fullPath}
                active={active}
                onClick={e => {
                  e.preventDefault();
                  onClose();
                  history.push(fullPath);
                }}
              >
                {view.mini && (
                  <DrawerChildMiniIcon active={active}>
                    {view.mini}
                  </DrawerChildMiniIcon>
                )}
                <LinkText>{view.name}</LinkText>
              </DrawerCollapseChildLink>
            );
          })}
        </DrawerCollapseChildren>
      )}
    </DrawerCollapseGroup>
  );
};

const MobileMenuDrawer = ({
  isOpen,
  onClose,
  routes,
  selectedOrganization,
  history,
}) => {
  const location = useLocation();

  // Filter routes by user role - same logic as Sidebar
  const filteredRoutesForRole = useMemo(() => {
    const userRole =
      selectedOrganization?.role ||
      localStorage.getItem("selected_organization_role") ||
      "";

    const filterRoutes = routesArr => {
      return routesArr
        .map(route => {
          if (route.collapse && route.views) {
            return { ...route, views: filterRoutes(route.views) };
          }
          return route;
        })
        .filter(route => {
          // Exclude quick actions route from mobile drawer
          if (route.path === "/quick-actions") return false;

          // Exclude restricted routes for current role
          if (
            route.restricted &&
            Array.isArray(route.restricted) &&
            userRole &&
            route.restricted.includes(userRole)
          ) {
            return false;
          }
          // Remove empty collapses
          if (route.collapse && route.views && route.views.length === 0)
            return false;
          return true;
        });
    };

    return filterRoutes(routes);
  }, [routes, selectedOrganization?.role]);

  const groupedLinks = useMemo(
    () => generateGroupedLinks(filteredRoutesForRole, selectedOrganization),
    [filteredRoutesForRole, selectedOrganization],
  );

  const orgName = selectedOrganization?.name || "";
  const orgColor = selectedOrganization?.color || "#3b3f48";
  const orgInitials = orgName
    ? orgName
        .split(" ")
        .slice(0, 2)
        .map(w => w[0])
        .join("")
        .toUpperCase()
    : "?";

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={onClose}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              zIndex: 1034,
            }}
          />
          {/* Drawer Panel */}
          <DrawerPanel
            isOpen={true}
            variants={drawerPanelVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <DrawerBody
              variants={drawerBodyVariants}
              initial="hidden"
              animate="visible"
            >
              {groupedLinks &&
                Object.keys(groupedLinks).map(group => {
                  const links = groupedLinks[group];
                  if (!links || links.length === 0) return null;
                  return (
                    <motion.div key={group} variants={groupVariants}>
                      <DrawerGroup>
                        {group !== "Common" && (
                          <DrawerGroupTitle>{group}</DrawerGroupTitle>
                        )}
                        {links.map((route, idx) => {
                          if (route.redirect) return null;
                          if (route.collapse && route.views) {
                            return (
                              <motion.div key={idx} variants={linkItemVariants}>
                                <CollapseSection
                                  route={route}
                                  location={location}
                                  onClose={onClose}
                                  history={history}
                                />
                              </motion.div>
                            );
                          }
                          if (!route.layout || !route.path) return null;
                          const fullPath = route.layout + route.path;
                          const active = isRouteActive(
                            fullPath,
                            location.pathname,
                          );
                          const icons = route.icon ? iconMap[route.icon] : null;
                          const iconSrc = active
                            ? icons?.active || icons?.filled || icons?.line
                            : icons?.line || icons?.filled;
                          return (
                            <motion.div key={idx} variants={linkItemVariants}>
                              <DrawerLinkItem
                                href={fullPath}
                                active={active}
                                onClick={e => {
                                  e.preventDefault();
                                  onClose();
                                  history.push(fullPath);
                                }}
                              >
                                {iconSrc && (
                                  <DrawerLinkIcon
                                    src={iconSrc}
                                    alt={route.name}
                                  />
                                )}
                                <LinkText>{route.name}</LinkText>
                              </DrawerLinkItem>
                            </motion.div>
                          );
                        })}
                      </DrawerGroup>
                    </motion.div>
                  );
                })}
            </DrawerBody>
          </DrawerPanel>
        </>
      )}
    </AnimatePresence>
  );
};

export default MobileMenuDrawer;
